export const FeaturedNews = (() => {
	'use strict';

	let $featuredNews,
		$stateFilters,
		$dateFilters,
		activeState,
		activeDate,
		currentUrl,
		newUrl;

	function init() {
		currentUrl = location.origin + location.pathname;
		$featuredNews = $('.pxblock--featured-news');
		
		if ($featuredNews) {
			setActiveFilters();

			$stateFilters = $featuredNews.find('.filter--state [data-state]');
			$dateFilters = $featuredNews.find('.filter--date [data-date]');

			$stateFilters.click(function(){
				let selection = $(this).data('state');
				$stateFilters.not(this).prop('checked', false);
				updateUrl();
			});

			$dateFilters.click(function(){
				let selection = $(this).data('state');
				$dateFilters.not(this).prop('checked', false);
				updateUrl();
			});
		}
	}

	function setActiveFilters(){
		let queryString = window.location.search;
		let urlParams = new URLSearchParams(queryString);
		let state = urlParams.get('state');
		let date = urlParams.get('date');

		if(state){
			$featuredNews.find('.filter--state [data-state='+state+']').prop('checked', true);
		}

		if(date){
			$featuredNews.find('.filter--date [data-date='+date+']').prop('checked', true);
		}
	}

	function updateUrl(){
		activeState = $featuredNews.find('.filter--state [data-state]:checked').data('state');
		activeDate = $featuredNews.find('.filter--date [data-date]:checked').data('date');

		newUrl = activeState || activeDate ? currentUrl+'?' : currentUrl;
		newUrl += activeState ? '&state='+activeState : '';
		newUrl += activeDate ? '&date='+activeDate : '';
	
		window.location.href = newUrl;
	}

	return {
		init: init,
		name: 'featured-news'
	};
})();
